// import React from 'react'
// import FilterComponents from '../../product/components/FilterComponents.tsx'
// import CustomDataGrid from '../../components/CustomDataGrid/CustomDataGrid.tsx';

// function AddTagsForHomePage(props) {

//     const columns = [
//         // {
//         //     field: 'checkbox',
//         //     headerName: 'Checkbox',
//         //     renderCell: () => <input type="checkbox" />,
//         // },
//         { field: 'Id', headerName: 'Id', width: 200 },
//         { field: 'name', headerName: 'Name', width: 200 },
//         // { field: 'duration', headerName: 'Duration', width: 200 },
//         // { field: 'isactive', headerName: 'IsActive', width: 200 }
//     ];

//     const dataRows = [
//         { id: 1,  Id: '10345', name: 'Pot Kettle Black', },
//         { id: 2,  Id: '22345', name: 'Pot Kettle Black London', }
//     ];

//   return (
//     <div>
//          <FilterComponents title={"OK"} isItem={14} />
//          <CustomDataGrid columns={columns} dataRows={dataRows} />
//     </div>
//   )
// }

// export default AddTagsForHomePage

import React, { useEffect, useState } from 'react';

// import Typography from '@mui/material/Typography'
// import Breadcrumbs from '@mui/material/Breadcrumbs'
// import Link from '@mui/material/Link'
import { Button, Grid } from '@mui/material'

import filterIcon from './../../../assets/icons/filter 1.png'
import searchIcon from './../../../assets/icons/searchIcon 1.png'
// import AddItemDialogComponent from './AddItemDialog.tsx'

// import FilterComponents from '../FilterComponents.tsx';
// import SectionTable from '../SectionTable.tsx';
// import AddSectionDialog from '../AddSectionDialog.tsx';
// import burger from './../../../../assets/icons/burger.png'
// import edit from './../../../../assets/icons/edit.png'
import bin from './../../../assets/icons/recycle-binColor.png'
import ediPencil from './../../../assets/icons/editPencil.png'
//table
// import arrowUp from './../../../assets/icons/arrowup.png'
// import arrowDown from './../../../assets/icons/arrowDown.png'

import Paper from '@mui/material/Paper';

// import Box from '@mui/material/Box'
// import Tab from '@mui/material/Tab'
// import TabContext from '@mui/lab/TabContext'
// import TabList from '@mui/lab/TabList'
// import TabPanel from '@mui/lab/TabPanel'
// import SectionItemsDialog from '../SectionItemsDialog/SectionItemsDialog.tsx';
//table end
import CustomDataGrid from '../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
// import EditSection from '../EditSection/EditSection.tsx';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingView from '../../components/LoadingView/LoadingView';
// import AddMenuDialog from '../AddMenuDialog.tsx';
// import KeywordDialog from '../KeywordDialog.tsx';
// import KeywordTagDialog from '../KeywordTagDialog.tsx';
import KeywordTagDialog from '../../product/components/KeywordTagDialog.tsx';
import SweetAlertModal from '../../components/SweetAlertModal/SweetAlertModal';
import arrowUp from './../../../assets/icons/arrowup.png'
import arrowDown from './../../../assets/icons/arrowDown.png'

const AddKeywordTag = () => {
    const [Loading, setLoading] = React.useState(false);
    const[open, setOpen]=useState(false)
    const [openConfirmaitonModal, setopenConfirmaitonModal]=useState(false)
    const [lastRank, setLastRank] = useState(1);

    const handleClickOpen = () => {
    
        setOpen(true)
    }
    const onDialogClose=(props)=>{
       
        setOpen(props)
        setOpenEditKeyword(props)
        
    }

    const changeOrder=(row, type)=>{
      
      
        axios
          .put(apiAddress + "/api/Keyword/UpdateKeywordTagRank?keywordtagId=" + row.id + "&status=" + type)
          .then((response) => {
            console.log(response.data);
            setDataRows([]);
            toast.success("Successfully updated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            loadKeywordTag()
          });
    }
   
    const apiAddress = process.env.REACT_APP_SECRET;
 
const[OpenEditKeyword, setOpenEditKeyword]=useState(false)
const[EditKeywordObj, setEditKeywordObj]=useState()
    const onEditClick = (props) => {
       console.log(props)
       console.log(dataRows)
        var obj=dataRows.find(x=>x.id==props)
        console.log(obj)
        var obj2={
            id:obj.id,
            imgurl:[obj.imgurl],
            name:obj.name
        }
        console.log(obj2)
        setEditKeywordObj(obj2)
        setOpenEditKeyword(true)
      }
    const columnsdatas = [

        {
            field: 'displayOrder',
            headerName: 'Display Order',
            renderCell: (params) =>
              <div className='d-flex align-items-center' style={{ gap: "10px" }}>
                <span className={`${params.row.displayOrder == 1 ? 'deselct' : ""}`} style={{ cursor: "pointer" }} onClick={() => { changeOrder(params.row, 2) }} >
                  <img src={arrowUp} style={{ width: "1rem" }} />
                </span>
                {/* <input type='number' className='form-control' style={{ width: "7rem" }} defaultValue={params.value} onChange={(event) => { changeOrderByTextBox(event, params.row) }} /> */}
                <span>{params.row.displayOrder}</span>
                <span className={`${params.row.displayOrder == lastRank? 'deselct' : ""}`} style={{ cursor: "pointer" }} onClick={() => { changeOrder(params.row, 1) }} >
                  <img src={arrowDown} style={{ width: "1rem" }} />
                </span>
              </div>,
            align: 'center',
            headerAlign: 'center',
            width: 200,
          },
    
        {
            field: 'name', headerName: 'KeywordTag Name', renderCell: (params) =>
                <div className='d-flex ' style={{ gap: "10px" }}>
                    <span
                        // onClick={() => { setsectionItemsToggle(true); setsectionItemsdialogType(params.value) }} 
                        style={{ color: "blue", cursor: "pointer" }}>{params.value}
                    </span>
                    <div style={{ color: "blue", cursor: "pointer" }}
                    onClick={() => { onEditClick(params.row.id) }}
                    >
                        <img src={ediPencil} alt="" style={{ width: "1rem" }} />
                    </div>

                </div>, align: 'center', headerAlign: 'center', flex: 1
        },
    
        {
            field: 'imgurl', headerName: 'Logo', align: 'center', headerAlign: 'center', flex: 1,
            renderCell: (params) => <img src={params.value} alt='burger' style={{ width: '2rem', height: '2rem' }} />
          },
    ];
    const [dataRows, setDataRows] = useState([])
    const [dataRowsCollection, setdataRowsCollection] = useState([])

    const loadKeywordTag=()=>{
        axios
        .get(apiAddress + "/api/Keyword/GetALlKeywordTag")
        .then((response) => {
            console.log(response.data);
            var list = [];
            response.data.map((dt, i) => {
                var obj = {
                    id: dt.id,
                    name: dt.keywordTagName,
                    imgurl: dt.keywordTagImage,
                    displayOrder:dt.displayOrder


                }
                list.push(obj)
            })
            setLastRank(list.length)
            setDataRows(list);
        });
    }
    useEffect(() => {
        loadKeywordTag()
    }, [])
    const[selectedDataRows, setSelectedDatarows]=useState([])
    const getselectedData = (props) => {
        console.log(props);
        setSelectedDatarows(props)
    }

    const deleteBin = () => {
        axios
            .put(apiAddress + "/api/Keyword/DeleteKeywordTag", selectedDataRows)
            .then((response) => {
                console.log(response.data);
                toast.success("Suuccesfully deleted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                  loadKeywordTag()
            });
            setopenConfirmaitonModal(false)
      
    }

    const errorToast=(msg)=>{
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const reloadData=()=>{
        loadKeywordTag()
    }
    return (
        <div>
            
            <ToastContainer></ToastContainer>
            <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to delete this?"} open={openConfirmaitonModal} onyes={deleteBin} close={() => { setopenConfirmaitonModal(false) }} />
            <LoadingView open={Loading} close={() => { setLoading(false) }} />

            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                mt={2}
                mb={2}
            >
                <Grid item>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Button
                                color="primary"
                                size="medium"
                                variant="contained"
                                style={{ borderRadius: '50%', minWidth: 'auto' }}
                                onClick={handleClickOpen}
                            >
                                +
                            </Button>
                        </Grid>
                        <Grid item>
                            <img src={filterIcon} alt="" style={{ width: '1rem' }} />
                        </Grid>
                        <Grid item>Add Filter</Grid>

                        <Grid item>
                            <div className='roundedCorner'>
                                <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => {selectedDataRows.length==0?errorToast("Please select a Tag"): setopenConfirmaitonModal(true) }} />
                            </div>
                        </Grid>
                        <Grid item>

                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container flexDirection={'column'} alignItems={'center'}>
                        <Grid item>
                            <img src={searchIcon} alt="" style={{ width: '1rem' }} />
                        </Grid>
                        <Grid item>Search</Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Paper sx={{ width: '100%', overflow: 'hidden' }}>

                {
                    dataRows.length > 0 ? (
                        <CustomDataGrid columns={columnsdatas} dataRows={dataRows} getselectedData={getselectedData} isLoading={Loading} />

                    ) : ("No Data found")

                }

            </Paper>
            {open?(
            <KeywordTagDialog open={open} onHandleKeywordDialog={onDialogClose} reloadData={reloadData}/>
            ):""}
            <KeywordTagDialog open={OpenEditKeyword} onHandleKeywordDialog={onDialogClose} editKeywordData={EditKeywordObj}/>
        </div>
    );
};

export default AddKeywordTag;